export function Logs() {}
export const Initial = [
  {
    method: "command",
    data: ["Demo command"]
  },
  {
    method: "result",
    data: ["Demo result"]
  }
];
